<template>
  <Select
    v-model="localValue"
    :name="name"
    :options="types"
    :multiple="multiple"
    :searchable="true"
    :rules="rules"
    :reduce="item => item.value"
    :placeholder="placeholder"
  />
</template>
<script>
import { mapState } from "vuex";
import Select from "../form/Select";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";

export default {
  name: "AlertTypeSelect",
  components: {
    Select
  },
  mixins: [formMixin, formOptionsMixin, formValidationMixin],
  computed: {
    types() {
      return this.alertTypes.map(x => ({ label: x.description, value: x.type }));
    },
    ...mapState({
      alertTypes: state => state.order.alertTypes
    })
  }
};
</script>
